import Checkbox from '@mui/material/Checkbox';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Checkbox": Checkbox, "@mui/icons-material/FavoriteBorder": FavoriteBorder, "@mui/icons-material/Favorite": Favorite, "@mui/icons-material/BookmarkBorder": BookmarkBorderIcon, "@mui/icons-material/Bookmark": BookmarkIcon } } });
export default ClientProvider;
